import { render, staticRenderFns } from "./JobCloseAsFutile.vue?vue&type=template&id=68e72d6e&scoped=true"
import script from "./JobCloseAsFutile.vue?vue&type=script&lang=ts"
export * from "./JobCloseAsFutile.vue?vue&type=script&lang=ts"
import style0 from "./JobActions.scss?vue&type=style&index=0&id=68e72d6e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e72d6e",
  null
  
)

export default component.exports